export default {
  sm: `
    IT 인프라 시설이 24시간 안정적으로 운영될 수 있도록 관리하는 본관은 근무자들의 이동 효율을 1순위로 고려하여 설계했습니다. 하이퍼스케일 데이터센터에서 필요한 업무들이 신속하게 수행될 수 있도록 서버관으로 빠르게 이동할 수 있는 지하 통로와 지상 브릿지 등이 구축되어 있습니다.
  `,
  xxl: `
    IT 인프라 시설이 24시간 안정적으로 운영될 수 있도록 관리하는 본관은 
    근무자들의 이동 효율을 1순위로 고려하여 설계했습니다.
    하이퍼스케일 데이터센터에서 필요한 업무들이 신속하게 수행될 수 
    있도록 서버관으로 빠르게 이동할 수 있는 지하 통로와 지상 브릿지 등이 구축되어 있습니다.
  `,
};
